<div class="ss-header-container">
  <!-- LEFT CONTAINER -->

  <div class="ss-header-left">
    <!-- MENU BUTTON -->

    <button
      *ngIf="this.currentUser().isCurrentlyLogged"
      kendoButton
      [svgIcon]="allIcons.menuIcon"
      fillMode="flat"
      themeColor="secondary"
      (click)="toggleSidenav.emit()"
      class="ss-header-hover-pointer"
    ></button>

    <!-- LOGO -->

    <img src="assets/img/logo-safestock.png" />

    <!-- BUDGET -->

    <div *ngIf="this.currentUser().isCurrentlyLogged && canSeeRemainingBudget && showBudget" class="ss-header-budget-container">
      <mat-icon>paid</mat-icon>
      {{ "layout.header.remainingBudget" | translate }} :
      <span class="ss-header-remainingBudget-text">{{ remainingBudget | dollarSignByLocal }}</span>
    </div>

    <!-- CATALOG -->

    <div *ngIf="currentCatalog && currentCatalog.catalogId" (click)="selectCatalog()" class="ss-header-catalog-container" [style.cursor]="canChangeCatalog ? 'pointer' : 'default'">
      <mat-icon>menu_book</mat-icon>
      <div class="ss-header-catalog-text-container">
        <span class="ss-header-catalog-text-customer">{{ currentCatalog.customerId | getCustomerInfo : customerList}}</span>
        <span class="ss-header-catalog-text-usergroup">{{ currentCatalog.userGroupHeaderId | getUserGroupInfo : userGroupList}}</span>
      </div>
      <span *ngIf="canChangeCatalog" class="ss-header-catalog-link-edit">(<span>modifier</span>)</span>
    </div>

    <!-- SHIP TO -->

    <div *ngIf="currentCatalog && currentCatalog.catalogId && currentShipTo && currentShipTo.shipToId" (click)="selectShipTo()" class="ss-header-shipto-container">
      <mat-icon>local_shipping</mat-icon>
      <span class="ss-header-shipto-text">{{ currentShipTo.shipToId }} - {{ currentShipTo.shipToName }}</span>
      <span class="ss-header-catalog-link-edit">(<span>modifier</span>)</span>
      
    </div>

      
  </div>

  <!-- RIGHT CONTAINER -->

  <div class="ss-header-right">

    <!-- Modify Personnal Comment -->
    
    <button
      class="ss-header-hover-pointer"
      kendoButton
      [svgIcon]="allIcons.trackChangesIcon"
      fillMode="flat"
      themeColor="primary"
      *ngIf="this.ShowEmployeeVisibleNotes"
      (click)="SeeUserPersonnalNotes()"
    ></button>

    <!-- HELP EMAIL -->

    <a href="mailto:vmi@spi.com"><kendo-svg-icon [icon]="allIcons.envelopeIcon" themeColor="primary"></kendo-svg-icon></a>

    <!-- MENU LANGUE-->

    <kendo-menu [openOnClick]="{ toggle: 'click' }">
      <kendo-menu-item>
        <ng-template kendoMenuItemTemplate>
          <kendo-svg-icon [icon]="allIcons.globeIcon" themeColor="primary"></kendo-svg-icon>
          {{ langue | uppercase }}
        </ng-template>
        <ng-template kendoMenuItemContentTemplate let-index="index">
          <div class="ss-header-menu-container ss-header-hover-pointer">
            <button kendoButton size="small" fillMode="flat" (click)="selectLangue('fr')">Français</button>
            <button kendoButton size="small" fillMode="flat" (click)="selectLangue('en')">English</button>
          </div>
        </ng-template>
      </kendo-menu-item>
    </kendo-menu>

    <!-- CART BUTTON -->
    <kendo-badge-container *ngIf="canSeeCartbutton">
      <button
          class="ss-header-hover-pointer"
          
          kendoButton
          [svgIcon]="allIcons.cartIcon"
          fillMode="flat"
          themeColor="secondary"
          [routerLink]="['/cart']"
        >
      </button>
        <kendo-badge rounded="full">{{numberOfItemsInCart}}</kendo-badge>
    </kendo-badge-container> 

    <!-- MENU USAGER (PROFIL / LOGOUT )-->

    <kendo-menu
      [openOnClick]="{ toggle: 'click' }"
      *ngIf="this.currentUser().isCurrentlyLogged"
    >
      <kendo-menu-item>

        <!-- CURRENT USER INFO -->

        <ng-template kendoMenuItemTemplate>
          <kendo-svg-icon [icon]="allIcons.userIcon" themeColor="primary"></kendo-svg-icon>
          {{ currentUser().userName }}
          <mat-icon *ngIf="this.isCurrentlyImpersonating">supervisor_account</mat-icon>
          </ng-template
        >
        <ng-template kendoMenuItemContentTemplate let-index="index">
          <div class="ss-header-menu-container">

            <!-- PROFILE -->
            <button kendoButton [svgIcon]="allIcons.userIcon" size="small" fillMode="flat" routerLink="/auth/profile">
              {{ "layout.header.button_profile" | translate }}
            </button>

            <!-- stop impersonation -->
            <button kendoButton size="small" fillMode="flat" *ngIf="this.isCurrentlyImpersonating" (click)="OnClickStopImpersonate()" class="ss-button-mat-icon">
              <mat-icon>supervisor_account</mat-icon>
              {{ "layout.header.button_stop_impersonation" | translate }}
            </button>

            <!-- LOGOUT -->
            <button kendoButton [svgIcon]="allIcons.xIcon" size="small" fillMode="flat"  (click)="OnLogoutClick()">
              {{ "layout.header.button_logout" | translate }}
            </button>

          </div>
        </ng-template>
      </kendo-menu-item>
    </kendo-menu>
  </div>
</div>
